import React from 'react'
import Link from 'gatsby-link'
import Header from './Header'
import Grid from 'styled-components-grid'
import {GridContainer, FullImage} from './Styles'
import logoAiles from './Header/logo-ailes-hautes-fine.png'
import Navigation from './Navigation'
import {Margin} from 'styled-components-spacing'

const Layout = (props) => (
  <div>
    <Header 
      navigationLinks={props.navigationLinks} 
      meteoLinks={props.meteoLinks}
      pagesUrl={props.pagesUrl}
      bannerImages={props.bannerImages}
    />
    <Grid>
      <Grid.Unit>
        {props.children}
      </Grid.Unit>
      <Grid.Unit>
        <Margin bottom={4}>
          <Navigation footer links={props.navigationLinks} injectContact={true} pagesUrl={props.pagesUrl} />
        </Margin>
      </Grid.Unit>
    </Grid>
  </div>
)

export default Layout


// WEBPACK FOOTER //
// ./src/components/Layout.js